// extracted by mini-css-extract-plugin
module.exports = {"formProyect":"styles_formProyect__2C3rA","container":"styles_container__2kuja"};